var map = {
	"./account.png": "bF3g",
	"./add_to_purchase_order.png": "7cgS",
	"./address.png": "fUxI",
	"./address_bottom_line.png": "m/dC",
	"./address_chosen.png": "y7Sk",
	"./address_empty.png": "8Kyu",
	"./ask_bg.png": "3vI9",
	"./back.png": "+O9w",
	"./bg_discount_no.png": "QrwD",
	"./bill.png": "frkF",
	"./brand.png": "gACX",
	"./brand_icon.png": "lW/q",
	"./caigou.png": "NfpV",
	"./cart.png": "JI+V",
	"./cart_active.png": "09Ht",
	"./cart_empty.png": "+93s",
	"./cart_icon.png": "oXUO",
	"./case.png": "PJXY",
	"./category.png": "+jvN",
	"./category_active.png": "dqrK",
	"./combination.png": "zyVG",
	"./combination_tc.png": "ixXu",
	"./compare.png": "qR4V",
	"./compare_check_chose.png": "jr7T",
	"./compare_check_normal.png": "j59n",
	"./complete.png": "v8n7",
	"./coupon_bg.png": "e0md",
	"./delete_icon.png": "s/IE",
	"./edit_icon.png": "egLk",
	"./error.png": "Dwgo",
	"./fav.png": "R4ij",
	"./fav_bg.png": "tJqy",
	"./finance.png": "d2N7",
	"./group.png": "vc67",
	"./groupon_tc.png": "1PYF",
	"./history.png": "/pJg",
	"./home.png": "2buq",
	"./home_active.png": "JtYa",
	"./icon_car.png": "QdAR",
	"./icon_check_normal.png": "0lhm",
	"./icon_check_pressed.png": "uZAx",
	"./icon_close_img.png": "j6Da",
	"./icon_delete.png": "+iEB",
	"./icon_news1.png": "Yi+C",
	"./icon_news2.png": "a+L9",
	"./icon_news3.png": "ZThC",
	"./icon_placeholder_normal.png": "n827",
	"./icon_sift_bottom.png": "hgjE",
	"./icon_sift_normal.png": "ssxo",
	"./icon_sift_top.png": "wHm8",
	"./index_ad.png": "CVDb",
	"./index_ad_cw.png": "KtwS",
	"./index_ad_hd.jpg": "vOHI",
	"./index_ad_hd_old.png": "j5do",
	"./index_ad_mys.png": "dd1n",
	"./integralMall.png": "mUVs",
	"./invoice.png": "TAjv",
	"./kefu.png": "6dvO",
	"./list_change0.png": "VdVL",
	"./list_change1.png": "hj1g",
	"./mine.png": "UN5s",
	"./mine_active.png": "oC38",
	"./more.png": "hM/W",
	"./needs.png": "hf2D",
	"./negotiate_no.png": "ByCN",
	"./news.png": "d9uo",
	"./news_word.png": "yXJE",
	"./part_pay.png": "NLWh",
	"./pre_sale.png": "/5cV",
	"./presale_tc.png": "rhAb",
	"./pro.png": "LY0b",
	"./promotion.png": "Jna1",
	"./promotion_bg.png": "OHyB",
	"./promotion_tc.png": "06Te",
	"./protect.png": "4UJq",
	"./save.png": "MBS0",
	"./search.png": "ldgE",
	"./search_empty.png": "DetN",
	"./seckill.png": "si7+",
	"./seckill_icon.png": "YEGu",
	"./seckill_tc.png": "AWAO",
	"./select.png": "OlPc",
	"./switch.png": "AUx6",
	"./title.png": "mBrL",
	"./un_fav.png": "ec8K",
	"./upload_images.png": "RxVu",
	"./upload_voucher.png": "Jfql",
	"./wait_confirm.png": "/tAg",
	"./wait_delivery.png": "p/O7",
	"./wait_pay.png": "h+XE",
	"./wait_take_delivery.png": "n8/t",
	"./weixin.png": "u7AJ",
	"./分类/brand1.png": "SCAc",
	"./分类/brand2.png": "A4Ic",
	"./分类/分类图片1@2x.png": "5mkQ",
	"./分类/分类图片1@3x.png": "AMMb",
	"./分类/分类图片2@2x.png": "HujT",
	"./分类/分类图片2@3x.png": "/f0g",
	"./分类/分类图片3@2x.png": "OCgx",
	"./分类/分类图片3@3x.png": "+Fvf",
	"./分类/切换经过@2x.png": "GE/U",
	"./分类/切换经过@3x.png": "wnBp",
	"./分类/切换经过拷贝@2x.png": "OaKQ",
	"./分类/切换经过拷贝@3x.png": "RVaz",
	"./分类/提问icon@2x.png": "iWMk",
	"./分类/提问icon@3x.png": "u1/e",
	"./分类/提问背景@2x.png": "QVmD",
	"./分类/提问背景@3x.png": "vqNB",
	"./分类/比价@2x.png": "ooPB",
	"./分类/比价@3x.png": "DH/B",
	"./分类/组23@2x.png": "XbZy",
	"./分类/组23@3x.png": "K04R",
	"./分类/组24@2x.png": "YDJn",
	"./分类/组24@3x.png": "4Ruk",
	"./底部/01首页默认icon@2x.png": "sSHG",
	"./底部/02首页选中icon@2x.png": "dcLt",
	"./底部/03分类默认icon@2x.png": "cBO0",
	"./底部/04分类选中icon@2x.png": "OpgJ",
	"./底部/05购物车默认icon@2x.png": "q5X8",
	"./底部/06购物车选中icon@2x.png": "aCWU",
	"./底部/09我的默认icon@2x.png": "o1Q4",
	"./底部/10我的选择icon@2x.png": "YESo",
	"./底部/cart.png": "orpu",
	"./底部/cart_active.png": "/KpA",
	"./底部/category.png": "csGj",
	"./底部/category_active.png": "/AUC",
	"./底部/home.png": "GlO9",
	"./底部/home_active.png": "Q6gm",
	"./底部/mine.png": "x6Un",
	"./底部/mine_active.png": "NnqX",
	"./底部/图层3@2x.png": "UM06",
	"./底部/图层3@3x.png": "sBWE",
	"./底部/返回icon@2x.png": "TUN9",
	"./底部/返回icon@3x.png": "Y1yb",
	"./登录注册/勾-已选@2x.png": "/yu1",
	"./登录注册/勾-已选@3x.png": "QHto",
	"./登录注册/勾-默认@2x.png": "3Qs5",
	"./登录注册/勾-默认@3x.png": "mtzq",
	"./登录注册/微信icon@2x.png": "14n0",
	"./登录注册/微信icon@3x.png": "gThG",
	"./登录注册/成功@2x.png": "D5mv",
	"./登录注册/成功@3x.png": "Xh2v",
	"./登录注册/登录界面切换icon@2x.png": "DxfK",
	"./登录注册/登录界面切换icon@3x.png": "HeWH",
	"./登录注册/返回@2x.png": "N8yt",
	"./登录注册/返回@3x.png": "zFw9",
	"./购物车/下载@2x.png": "+lqB",
	"./购物车/下载@3x.png": "aFR/",
	"./购物车/优惠券@2x.png": "Eq6H",
	"./购物车/优惠券@3x.png": "L2EC",
	"./购物车/优惠券背景@2x.png": "ACIR",
	"./购物车/优惠券背景@3x.png": "VUSd",
	"./购物车/删除红色@2x.png": "uogl",
	"./购物车/删除红色@3x.png": "Qc5t",
	"./购物车/喜欢标题@2x.png": "fZJR",
	"./购物车/喜欢标题@3x.png": "T/GN",
	"./购物车/圆角矩形1@2x.png": "4mB4",
	"./购物车/圆角矩形1@3x.png": "3Hpu",
	"./购物车/圆角矩形2@2x.png": "kz3Q",
	"./购物车/圆角矩形2@3x.png": "O9Tz",
	"./购物车/地址横线@2x.png": "8/Vu",
	"./购物车/地址横线@3x.png": "hhew",
	"./购物车/微信@2x.png": "BhZI",
	"./购物车/微信@3x.png": "TBEH",
	"./购物车/成功icon@2x@2x.png": "LcBa",
	"./购物车/成功icon@2x@3x.png": "6JAm",
	"./购物车/支付1@2x.png": "SuG5",
	"./购物车/支付1@3x.png": "Gr7e",
	"./购物车/支付2@2x.png": "GBn+",
	"./购物车/支付2@3x.png": "gLSM",
	"./购物车/支付3@2x.png": "V4TA",
	"./购物车/支付3@3x.png": "Wt5O",
	"./购物车/支付4@2x.png": "6/G8",
	"./购物车/支付4@3x.png": "EJ/H",
	"./购物车/支付5@2x.png": "PQZH",
	"./购物车/支付5@3x.png": "FOIr",
	"./购物车/数量@2x.png": "DCap",
	"./购物车/数量@3x.png": "jkGj",
	"./购物车/暂无配送地址icon@2x@2x.png": "dmG2",
	"./购物车/暂无配送地址icon@2x@3x.png": "HOzu",
	"./购物车/更多拷贝@2x.png": "4Rku",
	"./购物车/更多拷贝@3x.png": "z0IH",
	"./购物车/未上传@2x.png": "iPou",
	"./购物车/未上传@3x.png": "K+mT",
	"./购物车/标题竖线@2x.png": "lk0l",
	"./购物车/标题竖线@3x.png": "OE+y",
	"./购物车/汇款@2x.png": "mBb6",
	"./购物车/汇款@3x.png": "+IKM",
	"./购物车/汇票@2x.png": "O88W",
	"./购物车/汇票@3x.png": "0vFP",
	"./购物车/编辑icon@2x.png": "YQpb",
	"./购物车/编辑icon@3x.png": "Le8u",
	"./购物车/购物车暂无icon@2x@2x.png": "jD2I",
	"./购物车/购物车暂无icon@2x@3x.png": "aEx5",
	"./购物车/选择@2x.png": "QDOY",
	"./购物车/选择@3x.png": "No7s",
	"./首页/产品图2@2x.png": "viY3",
	"./首页/产品图2@3x.png": "TJ+i",
	"./首页/产品图@2x.png": "H+2M",
	"./首页/产品图@3x.png": "VVFP",
	"./首页/从低到高@2x - 副本.png": "mGBV",
	"./首页/从低到高@2x.png": "4J6T",
	"./首页/从低到高@3x.png": "FuO6",
	"./首页/从高到低@2x - 副本.png": "nsd8",
	"./首页/从高到低@2x.png": "T6EP",
	"./首页/从高到低@3x.png": "30Xa",
	"./首页/供应链金融/dianhua的副本@2x.png": "1Jg4",
	"./首页/供应链金融/dianhua的副本@3x.png": "7xKH",
	"./首页/供应链金融/不挑@2x.png": "aaW3",
	"./首页/供应链金融/不挑@3x.png": "sZTS",
	"./首页/供应链金融/个性化@2x.png": "jloi",
	"./首页/供应链金融/个性化@3x.png": "1L0L",
	"./首页/供应链金融/便利@2x.png": "0GJ6",
	"./首页/供应链金融/便利@3x.png": "g3r8",
	"./首页/供应链金融/信用@2x.png": "+kle",
	"./首页/供应链金融/信用@3x.png": "gN1S",
	"./首页/供应链金融/公平@2x.png": "W5LJ",
	"./首页/供应链金融/公平@3x.png": "ybjX",
	"./首页/供应链金融/关闭icon@2x.png": "W5/h",
	"./首页/供应链金融/关闭icon@3x.png": "4HaM",
	"./首页/供应链金融/创建icon@2x.png": "k1sM",
	"./首页/供应链金融/创建icon@3x.png": "AQJo",
	"./首页/供应链金融/利率低@2x.png": "yKJW",
	"./首页/供应链金融/利率低@3x.png": "Pu/l",
	"./首页/供应链金融/加入icon@2x.png": "8ZY7",
	"./首页/供应链金融/加入icon@3x.png": "gplB",
	"./首页/供应链金融/在线@2x.png": "EJgA",
	"./首页/供应链金融/在线@3x.png": "VoyU",
	"./首页/供应链金融/存@2x.png": "ku9C",
	"./首页/供应链金融/存@3x.png": "kA0A",
	"./首页/供应链金融/成本低@2x.png": "ow03",
	"./首页/供应链金融/成本低@3x.png": "7W1Y",
	"./首页/供应链金融/服务佳@2x.png": "/XkE",
	"./首页/供应链金融/服务佳@3x.png": "+C1i",
	"./首页/供应链金融/标题icon2@2x.png": "GxnW",
	"./首页/供应链金融/标题icon2@3x.png": "4vmZ",
	"./首页/供应链金融/标题背景@2x.png": "BNKV",
	"./首页/供应链金融/标题背景@3x.png": "J639",
	"./首页/供应链金融/申请快@2x.png": "hGon",
	"./首页/供应链金融/申请快@3x.png": "yzsz",
	"./首页/供应链金融/省费用@2x.png": "UAM6",
	"./首页/供应链金融/省费用@3x.png": "1/49",
	"./首页/供应链金融/票@2x.png": "9VnB",
	"./首页/供应链金融/票@3x.png": "i75D",
	"./首页/供应链金融/自主@2x.png": "59Ld",
	"./首页/供应链金融/自主@3x.png": "Z874",
	"./首页/供应链金融/订@2x.png": "i4xM",
	"./首页/供应链金融/订@3x.png": "ae/5",
	"./首页/供应链金融/赠利@2x.png": "V1Ic",
	"./首页/供应链金融/赠利@3x.png": "Q3RX",
	"./首页/供应链金融/通@2x.png": "OGzO",
	"./首页/供应链金融/通@3x.png": "bIie",
	"./首页/供应链金融/金融背景@2x.png": "oqn0",
	"./首页/供应链金融/金融背景@3x.png": "cDbW",
	"./首页/供应链金融/随采@2x.png": "dJn9",
	"./首页/供应链金融/随采@3x.png": "kCe9",
	"./首页/供应链金融/项目优@2x.png": "Oe+K",
	"./首页/供应链金融/项目优@3x.png": "kEDp",
	"./首页/供应链金融/额度高@2x.png": "fIHl",
	"./首页/供应链金融/额度高@3x.png": "LNUG",
	"./首页/促销优惠@2x.png": "ASA2",
	"./首页/促销优惠@3x.png": "4LTQ",
	"./首页/促销优惠icon@2x.png": "GPdN",
	"./首页/促销优惠icon@3x.png": "5QH1",
	"./首页/促销背景@2x.png": "dA5V",
	"./首页/促销背景@3x.png": "Jsfm",
	"./首页/切换选中@2x.png": "Pcck",
	"./首页/切换选中@3x.png": "cb0a",
	"./首页/切换默认@2x.png": "jqI5",
	"./首页/切换默认@3x.png": "rrUE",
	"./首页/列表切换2@2x.png": "dJMl",
	"./首页/列表切换2@3x.png": "AT1C",
	"./首页/列表切换@2x.png": "Mpc2",
	"./首页/列表切换@3x.png": "D5/4",
	"./首页/删除@2x.png": "AYYm",
	"./首页/删除@3x.png": "zEoo",
	"./首页/加入采购单@2x.png": "GNUn",
	"./首页/加入采购单@3x.png": "ajpU",
	"./首页/右@2x.png": "PGtf",
	"./首页/右@3x.png": "hw/r",
	"./首页/向上icon@2x.png": "mHUc",
	"./首页/向上icon@3x.png": "NOoY",
	"./首页/品牌@2x.png": "87LN",
	"./首页/品牌@3x.png": "1RIK",
	"./首页/品牌banner.png": "32Zm",
	"./首页/品牌icon@2x.png": "Vy6l",
	"./首页/品牌icon@3x.png": "2jJq",
	"./首页/品牌logo2@2x.png": "6kps",
	"./首页/品牌logo2@3x.png": "zfzt",
	"./首页/品牌logo3@2x.png": "UL3C",
	"./首页/品牌logo3@3x.png": "39N4",
	"./首页/品牌logo@2x.png": "axjR",
	"./首页/品牌logo@3x.png": "DC1O",
	"./首页/商品详情@2x.png": "sgAE",
	"./首页/商品详情@3x.png": "5x5O",
	"./首页/商品轮播图@2x.png": "cQgM",
	"./首页/商品轮播图@3x.png": "+zMF",
	"./首页/图层1.png": "o5bz",
	"./首页/图层101.png": "1WQ9",
	"./首页/图层2.png": "9zfP",
	"./首页/地址icon@2x.png": "A3gm",
	"./首页/地址icon@3x.png": "//YU",
	"./首页/头盔.png": "Hqr5",
	"./首页/客服icon@2x.png": "BQ7K",
	"./首页/客服icon@3x.png": "Bn08",
	"./首页/左@2x.png": "YKBX",
	"./首页/左@3x.png": "Axb3",
	"./首页/搜索@2x.png": "JYYG",
	"./首页/搜索@3x.png": "wVVI",
	"./首页/搜索暂无icon@2x@2x.png": "xInG",
	"./首页/搜索暂无icon@2x@3x.png": "F2ZU",
	"./首页/收藏-已点@2x.png": "7aUp",
	"./首页/收藏-已点@3x.png": "o231",
	"./首页/收藏-默认@2x.png": "tIZY",
	"./首页/收藏-默认@3x.png": "xA0S",
	"./首页/新建文件夹/品牌banner.png": "SNpL",
	"./首页/新建文件夹/图层101.png": "tIDB",
	"./首页/新建文件夹/头盔.png": "B/J8",
	"./首页/新建文件夹/资讯.png": "Y0UR",
	"./首页/新建文件夹/首页banner.png": "Nk0r",
	"./首页/新建文件夹/首页banner2.png": "i97G",
	"./首页/方案背景@2x.png": "oagD",
	"./首页/方案背景@3x.png": "XJp3",
	"./首页/更多icon@2x.png": "m9Q4",
	"./首页/更多icon@3x.png": "4uZw",
	"./首页/未选中@2x.png": "aYC8",
	"./首页/未选中@3x.png": "kee4",
	"./首页/标题icon2@2x.png": "xRXG",
	"./首页/标题icon2@3x.png": "HCf3",
	"./首页/标题icon@2x.png": "X9pR",
	"./首页/标题icon@3x.png": "OYwj",
	"./首页/活动/促销@2x.png": "ZTjb",
	"./首页/活动/促销@3x.png": "QN1Y",
	"./首页/活动/团购@2x.png": "ljZo",
	"./首页/活动/团购@3x.png": "Zcju",
	"./首页/活动/秒杀@2x.png": "bU02",
	"./首页/活动/秒杀@3x.png": "cUgx",
	"./首页/活动/组合@2x.png": "1wN/",
	"./首页/活动/组合@3x.png": "6AJ7",
	"./首页/活动/预售@2x.png": "0/pl",
	"./首页/活动/预售@3x.png": "LrRM",
	"./首页/海报@2x.png": "qs9W",
	"./首页/海报@3x.png": "9gxp",
	"./首页/消息/xiaoxi2@2x.png": "JfE7",
	"./首页/消息/xiaoxi2@3x.png": "Sgni",
	"./首页/消息/消息1@2x.png": "9tDt",
	"./首页/消息/消息1@3x.png": "aURt",
	"./首页/消息/消息3@2x.png": "9D6W",
	"./首页/消息/消息3@3x.png": "EUQC",
	"./首页/消息@2x.png": "gjKr",
	"./首页/消息@3x.png": "TDdO",
	"./首页/渐变背景@2x.png": "EaN8",
	"./首页/渐变背景@3x.png": "meSJ",
	"./首页/积分商城@2x.png": "1j6m",
	"./首页/积分商城@3x.png": "qNUP",
	"./首页/筛选@2x.png": "WQ/x",
	"./首页/筛选@3x.png": "FSRl",
	"./首页/筛选更多@2x.png": "JPoN",
	"./首页/筛选更多@3x.png": "+yHk",
	"./首页/箭头@2x.png": "65Ry",
	"./首页/箭头@3x.png": "vrQ2",
	"./首页/组6拷贝4@2x.png": "RABn",
	"./首页/组6拷贝4@3x.png": "wQyJ",
	"./首页/解决方案@2x.png": "3j+Z",
	"./首页/解决方案@3x.png": "AYgy",
	"./首页/购物车icon@2x.png": "c7jr",
	"./首页/购物车icon@3x.png": "F58S",
	"./首页/资讯.png": "JUuV",
	"./首页/资讯1@2x.png": "VrzN",
	"./首页/资讯1@3x.png": "bMFm",
	"./首页/资讯@2x.png": "5NPx",
	"./首页/资讯@3x.png": "2r52",
	"./首页/资讯图标/1@2x.png": "bbsA",
	"./首页/资讯图标/1@3x.png": "o7e7",
	"./首页/资讯图标/2@2x.png": "TRSU",
	"./首页/资讯图标/2@3x.png": "sGnQ",
	"./首页/资讯图标/3@2x.png": "uYMd",
	"./首页/资讯图标/3@3x.png": "bVL6",
	"./首页/资讯图标/4@2x.png": "5Sfh",
	"./首页/资讯图标/4@3x.png": "4GHN",
	"./首页/资讯图标/5@2x.png": "koTe",
	"./首页/资讯图标/5@3x.png": "8exO",
	"./首页/资讯图标/6@2x.png": "/gBR",
	"./首页/资讯图标/6@3x.png": "TICP",
	"./首页/资讯海报@2x.png": "GIcs",
	"./首页/资讯海报@3x.png": "l4Zr",
	"./首页/返回icon拷贝@2x.png": "AHHZ",
	"./首页/返回icon拷贝@3x.png": "kE06",
	"./首页/选中icon@2x.png": "rfxD",
	"./首页/选中icon@3x.png": "Cg3X",
	"./首页/金融@2x.png": "M2GG",
	"./首页/金融@3x.png": "20RP",
	"./首页/降价@2x.png": "Hdw0",
	"./首页/降价@3x.png": "0iE+",
	"./首页/限时秒杀@2x.png": "vZRo",
	"./首页/限时秒杀@3x.png": "8Zx3",
	"./首页/首页banner.png": "VDbG",
	"./首页/首页banner2.png": "qI+b"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BNgz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile ^\.\/.*$
// module id = BNgz
// module chunks = 192